import { IStorageUser, OnlineStorage } from "@tblabs/storage";
import { JsonViewer, Line, Snack } from "@tblabs/truffle";
import { DangerButton } from "../Components/DangerButton";
import { Panel } from "../Components/Panel";
import { PrimaryButton } from "../Components/PrimaryButton";
import { Page } from "./Page";


export class UserViewPage extends Page
{
    constructor(private _storage: OnlineStorage, private userId: string)
    {
        super("User view");

        this.Content(async () =>
        {
            const user = await this._storage.GetUser(this.userId);

            const title = `${user.Role || "(role unspecified)"} ${this.userId.toUpperCase()}`;

            this.body.Append(
                new Panel(title, [
                    new Line(),
                    new PrimaryButton("Edit").OnClick(() => window.location.hash = `admin/user/${this.userId}/edit`),
                    new DangerButton("Delete").OnClick(() => this.DeleteUser(user)).MarginLeft(12),
                ]),
                new Panel("Fields", [
                    new JsonViewer(user, undefined, {
                        keyStyle: "color: #d2d2d2;",
                        stringStyle: "color: #fdfdfd;",
                        numberStyle: "color: #fdfdfd;",
                        boolStyle: "color: #fdfdfd;",
                        nullStyle: "color: #fdfdfd;",
                        foldAll: false
                    })
                ]),
            );
        });
    }

    private async DeleteUser(user: IStorageUser)
    {
        if (confirm("Are you sure you want to delete this user?"))
        {
            await this._storage.DeleteUser(user);

            new Snack("✅ User deleted");

            window.location.hash = "admin/database";
        }
    }
}
